module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/offerte-min/offerte-min.component.scss
// module id = ./src/app/offerte-min/offerte-min.component.scss
// module chunks = main